var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    width: 42,
    height: 42,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5134 20.4978C16.4189 18.0399 20.3569 16.4195 22.3273 15.6366C27.9531 13.4013 29.1221 13.013 29.884 13.0001C30.0516 12.9973 30.4263 13.037 30.669 13.2251C30.874 13.384 30.9303 13.5986 30.9573 13.7492C30.9843 13.8998 31.0179 14.2429 30.9912 14.511C30.6863 17.571 29.3672 24.9968 28.6961 28.424C28.4121 29.8742 27.853 30.3605 27.3116 30.408C26.1352 30.5114 25.2419 29.6654 24.1025 28.9519C22.3196 27.8354 21.3123 27.1404 19.5816 26.0509C17.5816 24.7918 18.8781 24.0998 20.018 22.9689C20.3163 22.6729 25.4996 18.1691 25.5999 17.7606C25.6124 17.7095 25.6241 17.519 25.5056 17.4184C25.3872 17.3179 25.2124 17.3523 25.0862 17.3796C24.9074 17.4184 22.0591 19.2168 16.5413 22.7749C15.7329 23.3052 15.0006 23.5636 14.3444 23.5501C13.6211 23.5351 12.2298 23.1594 11.1955 22.8382C9.9268 22.4442 8.91851 22.236 9.00631 21.5669C9.05204 21.2184 9.55439 20.8621 10.5134 20.4978Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.187919bef52e7aeefa73aad73b5977b7.svg";
export { ForwardRef as ReactComponent };